<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Preface</a></div>
<div class="SOM_pre"><a href="#/pre3">Method in Systematic Theology - An Introduction - <i>Stanley E. Porter and Steven M. Studebaker</i></a></div>
<div class="SOM_part"><a href="#/p1">PART ONE: FIVE VIEWS OF EVANGELICAL THEOLOGICAL METHOD</a></div>
<div class="SOM_chap"><a href="#/p1chap1">1 Bible Doctrines/Conservative Theology: Codifying God’s Word - <i>Sung Wook Chung</i></a></div>
<div class="SOM_chap"><span href="#/p1chap2" title="Link target outside of Sample">2 Missional Theology: Living God’s Love - <i>John R. Franke</i></span></div>
<div class="SOM_chap"><span href="#/p1chap3" title="Link target outside of Sample">3 Interdisciplinary Theology: Framers and Painters - <i>Telford C. Work</i></span></div>
<div class="SOM_chap"><span href="#/p1chap4" title="Link target outside of Sample">4 Contextual Theology: God in Human Context - <i>Victor Ifeanyi Ezigbo</i></span></div>
<div class="SOM_chap"><span href="#/p1chap5" title="Link target outside of Sample">5 Trinitarian Dogmatic Theology: Confessing the Faith - <i>Paul Louis Metzger</i></span></div>
<div class="SOM_part"><span href="#/p2" title="Link target outside of Sample">PART TWO: RESPONSES</span></div>
<div class="SOM_chap"><span href="#/p2chap1" title="Link target outside of Sample">6 A Bible Doctrines/Conservative Theology Response - <i>Sung Wook Chung</i></span></div>
<div class="SOM_chap"><span href="#/p2chap2" title="Link target outside of Sample">7 A Missional Theology Response - <i>John R. Franke</i></span></div>
<div class="SOM_chap"><span href="#/p2chap3" title="Link target outside of Sample">8 An Interdisciplinary Theology Response - <i>Telford C. Work</i></span></div>
<div class="SOM_chap"><span href="#/p2chap4" title="Link target outside of Sample">9 A Contextual Theology Response - <i>Victor Ifeanyi Ezigbo</i></span></div>
<div class="SOM_chap"><span href="#/p2chap5" title="Link target outside of Sample">10 A Trinitarian Dogmatic Theology Response - <i>Paul Louis Metzger</i></span></div>
<div class="SOM_appen"><span href="#/p2chap6" title="Link target outside of Sample">What Have We Learned Regarding Theological Method, and Where Do We Go from Here? Tentative Conclusions - <i>Stanley E. Porter and Steven M. Studebaker</i></span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Contributors</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Author Index</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Subject Index</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">Scripture Index</span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen10" title="Link target outside of Sample">Praise for <i>Evangelical Theological Method</i></span></div>
<div class="SOM_appen"><span href="#/appen11" title="Link target outside of Sample">About the Editors</span></div>
<div class="SOM_appen"><span href="#/moreIVP" title="Link target outside of Sample">More Titles from InterVarsity Press </span></div>
<div class="SOM_pdf"><span href="#/ident11#copy1" title="Link target outside of Sample">Copyright</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?365f334a